/**
 * Converts Persian and Arabic-Indic digits to English digits (0-9).
 * Use when the user's keyboard or input may be in a different script (e.g. RTL locales).
 */
export function normalizeDigitsToEnglish(str: string): string {
  if (typeof str !== "string" || str.length === 0) return str;
  return str.replace(/[\u0660-\u0669\u06F0-\u06F9]/g, (d) => {
    const code = d.charCodeAt(0);
    const digit = code >= 0x06f0 ? code - 0x06f0 : code - 0x0660;
    return String.fromCharCode(0x30 + digit);
  });
}
